import mammoth from "mammoth";

export const exportJsonToFileWithPrompt = async (
  name: string,
  jsonObject: any
) => {
  const jsonStr = JSON.stringify(jsonObject, null, 2);
  const blob = new Blob([jsonStr], { type: "application/json" });
  if (!window.showSaveFilePicker) {
    throw new Error("Save File Picker is not supported in this browser.");
  }
  const validName = name.replace(/[<>:"/\\|?*]+/g, "_");
  const handle = await window.showSaveFilePicker({
    suggestedName: validName + ".fmap",
    types: [
      {
        description: "FocusMap Files",
        accept: { "application/json": [".json", ".fmap"] },
      },
    ],
  });
  const writable = await handle.createWritable();
  await writable.write(blob);
  await writable.close();
};

export const importJsonFromFileWithPrompt = async (): Promise<any> => {
  if (!window.showOpenFilePicker) {
    throw new Error("Select File Picker is not supported in this browser.");
  }
  const [fileHandle] = await window.showOpenFilePicker({
    types: [
      {
        description: "FocusMap Files",
        accept: { "application/json": [".json", ".fmap"] },
      },
    ],
  });
  const file = await fileHandle.getFile();
  const fileContent = await file.text();
  return JSON.parse(fileContent);
};

export const importWordFromFile = async (): Promise<any> => {
  if (!window.showOpenFilePicker) {
    throw new Error("Select File Picker is not supported in this browser.");
  }
  const [fileHandle] = await window.showOpenFilePicker({
    types: [
      {
        description: "Word Files",
        accept: {
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            [".docx"],
        },
      },
    ],
  });
  const file = await fileHandle.getFile();
  try {
    const arrayBuffer = await file.arrayBuffer();
    const document = await mammoth.convertToHtml({ arrayBuffer });

    var html = document.value; // The generated HTML
    var messages = document.messages; // Any messages, such as warnings during conversion
    return { document: html, fileName: file.name, messages };
  } catch (err) {
    console.log(err);
  }
};
